import { ActivityMetaType, type ActivityMeta } from '@/models/Activity';

export const listenActivityMetaMap: Record<number, ActivityMeta> = {
  40043: {
    name: 'Loud & Clear',
    type: ActivityMetaType.listen,
    icon: 'waveform-lines',
  },
  40045: {
    name: 'Your Voice',
    type: ActivityMetaType.listen,
    icon: 'waveform-lines',
  },
  40046: {
    name: 'Write It Right',
    type: ActivityMetaType.listen,
    icon: 'waveform-lines',
  },
  40048: {
    name: 'Get the Message',
    type: ActivityMetaType.listen,
    icon: 'waveform-lines',
  },
  40061: {
    name: 'GoodCast',
    type: ActivityMetaType.listen,
    icon: 'rocket-launch',
  },
};
